import Lang from "../../userPreferences/staticWords";
const LookupItem = ({ lookup, index, setSelectedLookup, selectedLookup }) => {
  return (
    <div
      key={index}
      id={index + 1}
      className="col-md-3 col-sm-6 col-11 px-2 mb-3"
      style={{ cursor: "pointer" }}
      onClick={() => {
        setSelectedLookup(lookup);
      }}
    >
      <div
        className="py-2 px-4 d-flex justify-content-center"
        style={{ backgroundColor: "rgb(242, 242, 242)", borderRadius: 10 }}
      >
        <p
          className="mb-0"
          style={{
            fontSize: 16,
            color: selectedLookup == lookup ? "rgb(26 115 232)" : "",
            fontWeight: selectedLookup == lookup ? "bold" : "",
          }}
        >
          {Lang[lookup]}
        </p>
      </div>
    </div>
  );
};
export default LookupItem;
